import { createContext, useContext, type ReactNode } from 'react';
import { useHearingSession, type UseHearingSessionResult } from '@/hooks/useHearingSession';

// One ask flow per hearing, shared by the ResponsePanel (buttons + feed) and
// the hotkey bridge in HearingShell. Before this, each called useHearingSession
// directly and got its own feed state, so hotkey-fired asks (F1-F4) updated a
// hidden second feed and never appeared on screen. Hoisting to a single context
// fixes that and gives the transcription safeguard (Section C) and the
// scrollable feed (Section D) a single source of truth.

const HearingSessionContext = createContext<UseHearingSessionResult | null>(null);

export function HearingSessionProvider({ children }: { children: ReactNode }) {
  const value = useHearingSession();
  return <HearingSessionContext.Provider value={value}>{children}</HearingSessionContext.Provider>;
}

export function useHearingSessionContext(): UseHearingSessionResult {
  const ctx = useContext(HearingSessionContext);
  if (!ctx) {
    throw new Error('useHearingSessionContext must be used inside <HearingSessionProvider>');
  }
  return ctx;
}
